import { useState } from "react";
import { useMediaQuery } from 'react-responsive';
import video from "../../Asset/Video/video";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import images from "../../Asset/Img/img";
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import "./Modal.css";
import { useTranslation } from 'react-i18next';

function ModalApp() {
    const [bigVideo, setBigVideo] = useState(false)
    const [modalOpen, setModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const smallScreen = useMediaQuery({ minWidth: 1025 })
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    function bigVideoClick() {
        setBigVideo(video.highVideo)
    }
    function bigVideoClose() {
        setBigVideo(false)
    }

    const imgGallery = [
        images.gallery1,
        images.gallery2,
        images.gallery3,
        images.gallery4
    ]

    const nextImage = () => {
        if (currentImageIndex === imgGallery.length - 1) {
            setCurrentImageIndex(0);
        } else {
            setCurrentImageIndex(currentImageIndex + 1);
        }
        setModalImage(imgGallery[currentImageIndex]);
    }

    const prevImage = () => {
        if (currentImageIndex === 0) {
            setCurrentImageIndex(imgGallery.length - 1);
        } else {
            setCurrentImageIndex(currentImageIndex - 1);
        }
        setModalImage(imgGallery[currentImageIndex]);
    }

    const { t} = useTranslation();

    return (
        <div className='gallery-container'>

            <div className='gallery-header'>
                <h3>{t("gallery-text")}</h3>
            </div>




            <div className='gallery-content' >

                <div className='gallery-video-container' >
                    <video className='static-video' src={video.highVideo} autoPlay loop muted onClick={bigVideoClick}></video>
                    {bigVideo && smallScreen &&
                        <div className='big-video' >
                            <div className='big-video-content'>
                                <button className='close' onClick={bigVideoClose}>  <FontAwesomeIcon icon={faXmark} className="close-icon" /> </button>
                                <video src={video.highVideo} autoPlay loop muted  ></video>
                            </div>
                        </div>
                    }
                </div>

                <div className='gallery-img-container'>
                    {imgGallery.map((image, index) => {
                        return <div className="static-img" key={index}>
                            <img src={image} alt="gallery" onClick={() => {
                                setModalOpen(true)
                                setModalImage(image)

                            }} />
                        </div>
                    })}
                    {modalOpen && smallScreen && (
                        <div className="dinamic-img-container">
                            <button className="dinamic-btn dinamic-btn-left" onClick={prevImage}><FontAwesomeIcon icon={faChevronLeft} className="close-icon-next" /> </button>
                            <div className="dinamic-img-content">
                                <button className="close" onClick={() => setModalOpen(false)}><FontAwesomeIcon icon={faXmark} className="close-icon" /> </button>
                                <img src={modalImage} alt="gallery" />
                            </div>
                            <button className="dinamic-btn dinamic-btn-right" onClick={nextImage}><FontAwesomeIcon icon={faChevronRight} className="close-icon-next" /> </button>
                        </div>

                    )}

                </div>


            </div>
        </div>
    )
}

export default ModalApp